<template>
  <div class="contract-dispatch">
    <div class="content-wrapper">
      <div class="h-full">
        <XzTagGroup
          :data="signStatusFlagList"
          :active="outform.signStatus"
          @handleClick="v => handleOutChange('signStatus', v)"
        >
          <span class="title">签署状态</span>
        </XzTagGroup>
        <div id="_contractDispatch" class="table-wrapper" :class="{ fullscreen: isFullScreen }">
          <xz-table
            ref="xzTable"
            :columns="columnLists"
            :data="data"
            :searchAttrs="searchAttrs"
            :searchVal.sync="outform.fileNameOrTaskCode"
            :toolsAttrs="toolsAttrs"
            :scroll="{ x: '100%', y: scrollHeight }"
            :drawerVisible.sync="drawerVisible"
            :drawerWidth="500"
            rowKey="id"
            :enableRowSelection="true"
            :selectedRowKeys="selectedKeys"
            @change="handleSelectionChange"
            @search="handleAdvancedQuery"
            @refresh="handleReset"
            @fullScreen="handleFullScreen"
          >
            <template #drawer>
              <div style="flex: 1; overflow: auto" class="contract-search">
                <el-form :model="form" label-width="80px">
                  <el-form-item label="关联单位">
                    <el-input v-model.trim="form.companyName" placeholder="请输入" clearable />
                  </el-form-item>
                  <el-form-item label="任务编号">
                    <el-input v-model.trim="form.taskCode" placeholder="请输入" clearable />
                  </el-form-item>
                  <el-form-item label="文件编号">
                    <el-input v-model.trim="form.fileCode" placeholder="请输入" clearable />
                  </el-form-item>
                  <el-form-item label="文件类型">
                    <el-select v-model="form.fileType" placeholder="请选择" clearable filterable>
                      <el-option label="全部" :value="null"></el-option>
                      <el-option label="PDF" value="PDF"></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
              <div style="text-align: right; height: 68px; line-height: 68px">
                <a-button @click="handleEmpty">重置</a-button>
                <a-button type="primary" style="margin-left: 10px" @click="handleAdvancedQuery">确定</a-button>
              </div>
            </template>
            <template #buttons>
              <!-- <el-button @click="handleContractDispatch" type="primary" size="mini" v-if="actionPermissionMap['electronicSign:contract_issue:fileIssue']">合同文件发起</el-button> -->
              <el-button @click="handleTencentUpload" type="primary" size="mini" v-if="actionPermissionMap['electronicSign:contract_issue:updateFiles']">更新文件库</el-button>
              <el-button @click="handleBatchUpload" :disabled="!selectedKeys.length" type="primary" size="mini" plain v-if="actionPermissionMap['electronicSign:contract_issue:batchUpload']">批量上传</el-button>
              <el-button @click="handleBatchDispatch" :disabled="!selectedKeys.length" type="primary" size="mini" plain v-if="actionPermissionMap['electronicSign:contract_issue:batchIssue']">批量发起</el-button>
              <el-button @click="handleBatchDownload" :disabled="!selectedKeys.length" type="primary" size="mini" plain>批量下载</el-button>
              <div style="display: inline-block;">上次更新时间：{{ lastUpdateTime }}</div>
            </template>
            <template slot="signatory" slot-scope="_, record">
              <div v-for="item in record.signatoryList" :key="item.id">
                {{ item.name }} {{ item.jobNumber }} {{ item.signRole }}
              </div>
            </template>
            <template slot="action" slot-scope="_, record">
              <el-button v-if="(record.finishFileUrl || record.uploadFileUrl) && actionPermissionMap['electronicSign:contract_issue:preview']" @click="handlePreview(record)" type="text" size="mini">预览</el-button>
              <el-button v-if="record.signStatus === 'WAIT_UPLOAD' && actionPermissionMap['electronicSign:contract_issue:upload']" @click="handleUpload(record)" type="text" size="mini">上传</el-button>
              <el-button v-if="['NOT_INITIATE_FLOW', 'RELIEVED', 'REVOKED'].includes(record.signStatus) && actionPermissionMap['electronicSign:contract_issue:issue']" @click="handleDispatch(record)" type="text" size="mini">发起</el-button>
            </template>
          </xz-table>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <a-pagination
        :current="page.pageNum"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        show-size-changer
        :pageSizeOptions="['10', '20', '30', '50', '100']"
        show-quick-jumper
        :pageSize.sync="page.pageSize"
        @change="handleNumChange"
        @showSizeChange="handleSizeChange"
      />
    </div>

    <el-dialog
      :title="`批量${batchTxt}`"
      :visible.sync="dispatchProgressDialog"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-align: center; padding: 30px;">
        <div style="margin-bottom: 30px;">
          已选择 {{ totalCount }} 个文件
        </div>
        <div v-if="totalCount">
          <template v-if="batchTxt === '上传'">
            <el-progress :text-inside="true" :stroke-width="25" :percentage="Number(progressPercentage)"></el-progress>
          </template>
          <template v-if="batchTxt === '发起'">
            <el-progress :text-inside="true" :stroke-width="25" :percentage="Number((((successCount + failCount) / totalCount ) * 100).toFixed(2))"></el-progress>
          </template>
          <template v-if="successCount + failCount !== totalCount">
            <i style="margin-top: 20px;font-size: 24px; color: #409EFF;" class="el-icon-loading"></i>
            <div style="font-size: 14px; color: #409EFF;">{{`正在${batchTxt}中`}}</div>
          </template>
          <template v-else>
            <i style="margin-top: 20px;font-size: 24px; color: #409EFF;" class="el-icon-success"></i>
            <div style="font-size: 14px; color: #409EFF;">{{`${batchTxt}结束`}}</div>
          </template>
        </div>
        <div style="margin-top: 20px;">
          {{`成功${batchTxt}`}} <b style="color: #67C23A;">{{ successCount }}</b> 个，{{`${batchTxt}失败`}} <b style="color: #F56C6C;">{{ failCount }}</b> 个
        </div>
      </div>
      <div v-if="batchTxt === '上传'" style="text-align: right; padding: 0 20px 20px;">
        <span style="font-size: 12px; color: #909399;"><i class="el-icon-warning"></i> 关闭弹窗后，上传任务将仍在后台运行，请耐心等待！</span>
        <el-button @click="()=> dispatchProgressDialog = false">关闭</el-button>
      </div>
      <div v-if="batchTxt === '发起'" style="text-align: right; padding: 0 20px 20px;">
        <el-button @click="handleCancelDispatch">{{ totalCount === successCount ? '关闭' : '取消任务' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import XzTagGroup from '@/components/xiaozi-ui/xz-tag-group';
import { getContractList, getContractQuality, createUrl, initiateFlow, getLatestRecordByDataTypeAndTenantId, reUploadContractFile, batchUploadFiles, getUploadProgress } from '@/api/e-signature';
import { mapGetters } from 'vuex';
import { zipFiles } from '@/utils/download';
import { fromBlob } from 'file-type/browser';
const COMMON_COLUMNS = [
  {
    title: '签署状态',
    dataIndex: 'signStatusDesc',
    key: 'signStatusDesc',
    width: 90,
    ellipsis: true,
  },
  {
    title: '任务编号',
    dataIndex: 'taskCode',
    key: 'taskCode',
    width: 160,
    ellipsis: true,
  },
  {
    title: '文件编号',
    dataIndex: 'fileCode',
    key: 'fileCode',
    width: 160,
    ellipsis: true,
  },
  {
    title: '文件名称',
    dataIndex: 'fileName',
    key: 'fileName',
    width: 180,
    ellipsis: true,
  },
  {
    title: '关联单位',
    dataIndex: 'companyName',
    key: 'companyName',
    width: 180,
    ellipsis: true,
  },
  {
    title: '所需签署方',
    dataIndex: 'signatoryList',
    key: 'signatoryList',
    width: 190,
    ellipsis: true,
    scopedSlots: { customRender: 'signatory' },
  },
  {
    title: '文件类型',
    dataIndex: 'fileType',
    key: 'fileType',
    width: 100,
    ellipsis: true,
  },
  {
    title: '上传时间',
    dataIndex: 'uploadTime',
    key: 'uploadTime',
    width: 170,
    ellipsis: true,
    customRender: text => {
      return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
    },
  },
  {
    title: '发起时间',
    dataIndex: 'initiateTime',
    key: 'initiateTime',
    width: 170,
    ellipsis: true,
    customRender: text => {
      return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
    },
  },
  {
    title: '签署完成时间',
    dataIndex: 'finishTime',
    key: 'finishTime',
    width: 170,
    customRender: text => {
      return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
    },
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    fixed: 'right',
    width: 110,
    scopedSlots: { customRender: 'action' },
  },
];
const SIGN_STATUS_ENUM = [
  {
    label: '待上传',
    value: 'WAIT_UPLOAD',
  },
  {
    label: '未发起',
    value: 'NOT_INITIATE_FLOW',
  },
  {
    label: '签署中',
    value: 'SIGNING',
  },
  {
    label: '已解除',
    value: 'RELIEVED',
  },
  {
    label: '已撤销',
    value: 'REVOKED',
  },
  {
    label: '已拒签',
    value: 'REJECTED',
  },
  {
    label: '已完成',
    value: 'FINISHED',
  },
];
export default {
  name: 'ContractDispatch',
  components: {
    xzTable,
    XzTagGroup,
  },
  data () {
    return {
      lastUpdateTime: '',
      drawerVisible: false,
      scrollHeight: 'calc(100vh - 350px)',
      isFullScreen: false,
      selectedKeys: [],
      selectedRows: [],
      selectedBatchKeys: [],
      searchAttrs: {
        show: true,
        placeholder: '文件名称/任务编号',
        data: 'fileNameOrTaskCode',
      },
      columnLists: [
        ...COMMON_COLUMNS,
      ],
      form: {
        companyName: '',
        taskCode: '',
        fileCode: '',
        fileType: null,
      },
      outform: {
        fileNameOrTaskCode: '',
        signStatus: null,
      },
      total: 0,
      data: [],
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      signStatusFlagList: [
        {
          label: '全部',
          value: null,
        },
        ...SIGN_STATUS_ENUM,
      ],
      batchTxt: '',
      totalCount: 0,
      successCount: 0,
      failCount: 0,
      progressPercentage: 0,
      cancelDispatch: false,
      dispatchProgressDialog: false,
      interval: null,
    };
  },
  computed: {
    ...mapGetters(['actionPermissionMap']),
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        advancedSearch: true,
      };
    },
  },
  methods: {
    handleOutChange (key, o) {
      this.selectedKeys = [];
      this.selectedRows = [];

      this.outform[key] = o.value;

      this.page.pageNum = 1;

      this.handleSearch();
    },
    handlePreview (record) {
      // 预览合同签署
      const url = record.finishFileUrl || record.uploadFileUrl;
      window.open(url);
    },
    async handleUpload (record) {
      await reUploadContractFile({
        contractId: record.id,
      });
      this.$message.success('操作成功！');
      this.handleSearch();
    },
    async handleDispatch (record) {
      // 发起合同签署
      await initiateFlow({
        contractId: record.id,
      });
      this.$message.success('操作成功！');
      this.handleSearch();
    },
    handleCancelDispatch () {
      this.cancelDispatch = true;
    },
    handleCloseDispatch () {
      this.batchTxt = '';
      this.totalCount = 0;
      this.successCount = 0;
      this.failCount = 0;
      this.progressPercentage = 0;
      this.selectedKeys = [];
      this.selectedRows = [];
      this.cancelDispatch = true;
      this.dispatchProgressDialog = false;
    },
    async handleBatchUpload () {
      this.selectedBatchKeys = [];
      if (!this.selectedKeys.length) {
        this.$message.warning('请先选择合同');
        return;
      }

      if (this.selectedRows.some(item => !['WAIT_UPLOAD'].includes(item.signStatus))) {
        this.$message.warning('只能选择待上传的合同');
        return;
      }

      // 过滤出待上传的合同id
      this.selectedBatchKeys = this.selectedRows.filter(item => item.id && item.signStatus === 'WAIT_UPLOAD').map(item => item.id);

      if (!this.selectedBatchKeys.length) {
        this.$message.warning('请先选择合同');
        return;
      }

      clearInterval(this.interval);
      this.interval = null;

      batchUploadFiles({
        contractIds: this.selectedBatchKeys,
      });

      setTimeout(() => {
        this.batchTxt = '上传';
        this.totalCount = 0;
        this.successCount = 0;
        this.failCount = 0;
        this.progressPercentage = 0;
        this.cancelDispatch = false;
        this.dispatchProgressDialog = true;
        this.queryProgress();
      }, 1000);

      // 轮询查询上传进度
      this.interval = setInterval(() => {
        this.queryProgress();
      }, 5000);
    },
    queryProgress () {
      getUploadProgress({}).then(res => {
        this.totalCount = res.body.totalCount || 0;
        this.failCount = res.body.failCount || 0;
        this.successCount = res.body.successCount || 0;
        this.progressPercentage = res.body.progressPercentage || 0;
        if (res.body.isFinished) {
          clearInterval(this.interval);
          this.interval = null;
          this.endBatchUpload();
        }
      });
    },
    endBatchUpload () {
      const msg = this.successCount === this.selectedBatchKeys.length ? `成功发起${this.successCount}个` : `成功发起${this.successCount}个，发起失败${this.failCount}个`;
      this.$message({
        message: msg,
        type: this.successCount === this.selectedBatchKeys.length ? 'success' : 'warning',
        duration: 3000,
      });
      setTimeout(() => {
        this.handleCloseDispatch();
        this.handleSearch();
      }, 3000);
    },
    async handleBatchDispatch () {
      this.selectedBatchKeys = [];
      if (!this.selectedKeys.length) {
        this.$message.warning('请先选择合同');
        return;
      }

      if (this.selectedRows.some(item => !['NOT_INITIATE_FLOW', 'RELIEVED', 'REVOKED'].includes(item.signStatus))) {
        this.$message.warning('只能选择未发起、已解除、已撤销的合同');
        return;
      }

      // 过滤出可发起的合同id
      this.selectedBatchKeys = this.selectedRows.filter(item => item.id && ['NOT_INITIATE_FLOW', 'RELIEVED', 'REVOKED'].includes(item.signStatus)).map(item => item.id);

      if (!this.selectedBatchKeys.length) {
        this.$message.warning('请先选择合同');
        return;
      }

      if (this.selectedBatchKeys.length > 50) {
        this.$message.warning('最多只能选择50个合同');
        return;
      }

      this.batchTxt = '发起';
      this.totalCount = this.selectedBatchKeys.length;
      this.successCount = 0;
      this.failCount = 0;
      this.progressPercentage = 0;
      this.cancelDispatch = false;
      this.dispatchProgressDialog = true;

      // 循环调接口发起合同签署
      for (const contractId of this.selectedBatchKeys) {
        if (this.cancelDispatch) break;
        await new Promise((resolve) => {
          initiateFlow({
            contractId,
          }).then(res => {
            this.successCount++;
            resolve(res);
          }).catch(err => {
            this.failCount++;
            resolve(err);
          });
        });
      }

      const msg = this.successCount === this.selectedBatchKeys.length ? `成功发起${this.successCount}个` : `成功发起${this.successCount}个，发起失败${this.failCount}个`;
      this.$message({
        message: msg,
        type: this.successCount === this.selectedBatchKeys.length ? 'success' : 'warning',
        duration: 3000,
      });
      setTimeout(() => {
        this.handleCloseDispatch();
        this.handleSearch();
      }, 3000);
    },
    async handleBatchDownload () {
      if (!this.selectedKeys.length) {
        this.$message.warning('请先选择合同');
        return;
      }

      // 过滤出有文件的合同
      const filesForDownload = this.selectedRows
        .filter(item => item.finishFileUrl || item.uploadFileUrl)
        .map(item => ({
          url: item.finishFileUrl || item.uploadFileUrl,
          fileName: item.fileName || `${item.taskCode}_${item.fileCode}`,
        }));

      if (!filesForDownload.length) {
        this.$message.warning('所选合同中没有可下载的文件');
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: `正在下载 ${filesForDownload.length} 个文件...`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      try {
        // 下载所有文件
        const downloadedFiles = await Promise.all(filesForDownload.map(async ({ url, fileName }) => {
          const res = await fetch(url);
          const blob = await res.blob();

          // 使用合同的文件名，如果没有扩展名则根据文件类型添加
          let finalFileName = fileName;
          if (finalFileName.indexOf('.') < 0) {
            try {
              const fileType = await fromBlob(blob);
              if (fileType && fileType.ext) {
                finalFileName = `${finalFileName}.${fileType.ext}`;
              }
            } catch (e) {
              // 如果无法检测文件类型，默认使用.pdf
              finalFileName = `${finalFileName}.pdf`;
            }
          }

          return {
            name: finalFileName,
            blob,
          };
        }));

        // 打包成zip文件
        const currentDate = Moment().format('YYYYMMDD_HHmmss');
        await zipFiles(downloadedFiles, `合同文件_${currentDate}`);
        this.$message.success(`成功下载 ${filesForDownload.length} 个文件`);
        this.selectedKeys = [];
        this.selectedRows = [];
      } catch (error) {
        console.error('批量下载失败:', error);
        this.$message.error('批量下载失败，请重试');
      } finally {
        loading.close();
      }
    },
    async handleTencentUpload () {
      await getContractQuality({});
      this.$message({
        message: '更新成功，若文件状态为【待上传】，请刷新页面，耐心等待文件上传',
        type: 'success',
        duration: 4000,
      });
      this.handleReset();
      this.queryLatestRecordByDataTypeAndTenantId();
    },
    async handleContractDispatch () {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (!userInfo || !userInfo.employeeMsg) {
        this.$message.error('请先登录');
        return;
      }
      const { body } = await createUrl({
        employeeId: userInfo.employeeMsg.id,
      });
      if (!body || !body.consoleUrl) {
        this.$message.error('生成链接失败！');
        return;
      }
      this.$router.push({
        path: '/e-signature/tencentUpload',
        query: {
          url: encodeURIComponent(body.consoleUrl),
        },
      });
    },
    handleSelectionChange (keys, rows) {
      this.selectedKeys = keys;
      this.selectedRows = rows;
    },
    handleEmpty () {
      this.form = this.$options.data().form;
    },
    handleReset () {
      this.outform = this.$options.data().outform;
      this.form = this.$options.data().form;
      this.page.pageNum = 1;
      this.page.pageSize = 10;

      this.handleSearch();
    },
    handleAdvancedQuery () {
      this.page.pageNum = 1;

      this.handleSearch();
    },
    handleSizeChange (_, size) {
      this.page.pageSize = size;

      this.handleSearch();
    },
    handleNumChange (num) {
      this.page.pageNum = num;

      this.handleSearch();
    },
    handleFullScreen (flag) {
      this.isFullScreen = flag;
    },
    async handleSearch () {
      let params = {
        ...this.outform,
        ...this.form,
        ...this.page,
        orderBy: [
          {
            orderByProperty: 'lastUpdateTime',
            orderByType: 'DESC',
          },
        ],
      };
      const { body } = await getContractList(params);
      this.data = body?.list || [];
      this.total = Number(body?.total || 0);
      if (this.drawerVisible) {
        this.drawerVisible = false;
      }
    },
    async queryLatestRecordByDataTypeAndTenantId () {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (!userInfo || !userInfo.tenantId) {
        this.$message.error('请先登录');
        return;
      }
      const { body } = await getLatestRecordByDataTypeAndTenantId({
        dataTypeEnum: 'KEDU_CNAS_CONTRACT_QUALITY',
        tenantId: userInfo.tenantId,
      });
      const time = body?.lastUpdateTime || '';
      this.lastUpdateTime = time ? Moment(time).format('YYYY-MM-DD HH:mm:ss') : '--';
    },
  },
  created () {
    this.queryLatestRecordByDataTypeAndTenantId();
    this.handleSearch();
  },
  beforeDestroy () {
    clearInterval(this.interval);
    this.interval = null;
  },
};
</script>
<style lang="scss" scoped>
.contract-dispatch {
  @mixin tag_round() {
    padding: 4px 8px;
    border-radius: 4px;
  }
  height: 100%;
  display: flex;
  flex-direction: column;

  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .h-full {
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .title {
        font-size: 14px;
        font-weight: 600;
        padding-right: 2em;
      }

      .table-wrapper {
        padding: 16px 12px;
        flex: 1;
        overflow: auto;

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #f2f4f7;

          &.active-radio {
            border-color: #e2f3fe;
            background-color: #e2f3fe;
            color: #237ffa;
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }

        .c_tag {
          @include tag_round();
          margin-right: 0.2em;
        }

        .orange {
          background-color: #fefae0;
          color: #fab007;
        }
        .red{
          background: #FEE9E5;
          color: #FF5959;
        }

        .green {
          background: #E5FEEB;
          color: #14CA64;
        }

        .grey {
          background-color: #F2F4F7;
          color: #1F2733;
        }
        .bule {
          background: #e2f3fe;
          color: #237ffa;
        }
      }
    }
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #ffffff;
  }

  /deep/.ant-table-body::-webkit-scrollbar {
    height: 12px;
    width: 12px;
  }

  /deep/ .ant-table-body::-webkit-scrollbar-thumb {
    border-radius: 8px;
    box-shadow: inset 0 0 5px #c9ced6;
    background: #c9ced6;
  }

  //鼠标移入样式
  /deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
    background: #c9ced6;
  }

  .contract-search {
    .ant-form-item {
      margin-bottom: 8px;
    }
  }

  /deep/.ant-drawer-body {
    padding: 16px;
  }
}
</style>
